import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, PackageCheck, Upload } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";

export function InventarioSoloUpload({ monthly, onDone }) {
  const [file, setFile] = useState(null);
  const [fecha, setFecha] = useState(new Date().toISOString().slice(0, 10));
  const [busy, setBusy] = useState(false);
  const ready = monthly?.ready;

  const subir = async () => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("inventario", file);
      fd.append("fecha_inventario", fecha);
      const { data } = await api.post("/uploads/inventory", fd, { timeout: 300000 });
      toast.success(`Inventario cruzado con 12 meses de ventas: ${data.name}`);
      setFile(null);
      onDone?.(data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "No se pudo subir el inventario");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card p-6 border-2 border-[#1f6fd1]/30" data-testid="inventario-solo-card">
      <div className="flex items-center gap-3 mb-2">
        <div className="h-10 w-10 rounded-lg bg-[#1f6fd1] text-white flex items-center justify-center"><PackageCheck size={18} /></div>
        <div>
          <h2 className="font-display text-lg font-bold">Subir solo el inventario actualizado</h2>
          <p className="text-xs text-slate-500">El listado de stock de tu programa, tal cual (Excel, CSV o TXT)</p>
        </div>
      </div>
      <p className="text-sm text-slate-600">Se cruza con los últimos 12 meses de ventas que ya has subido (venta libre y con receta) y se guarda como un estudio nuevo con su fecha, sin borrar los anteriores.</p>
      {!ready ? (
        <div className="mt-4 text-sm bg-amber-50 border border-amber-200 text-amber-900 rounded px-3 py-2" data-testid="inventario-solo-not-ready">
          Necesitas 12 meses seguidos de ventas subidas; ahora tienes {monthly?.consecutive_months || 0}.{" "}
          <Link to="/subidas/ventas" className="underline font-semibold">Subir ventas mes a mes</Link>
        </div>
      ) : (
        <div className="mt-4 grid sm:grid-cols-[1fr_auto_auto] gap-3 items-end">
          <label className="text-xs text-slate-500">Fichero de inventario
            <input type="file" accept=".xlsx,.xls,.xlsm,.csv,.txt" onChange={(e) => setFile(e.target.files?.[0] || null)}
                   className="input mt-1 text-sm" data-testid="inventario-solo-file" />
          </label>
          <label className="text-xs text-slate-500">Fecha del inventario
            <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} className="input mt-1 text-sm" data-testid="inventario-solo-fecha" />
          </label>
          <button onClick={subir} disabled={!file || busy} className="btn btn-primary" data-testid="inventario-solo-submit">
            {busy ? <><Loader2 size={14} className="animate-spin" /> Procesando…</> : <><Upload size={14} /> Subir inventario</>}
          </button>
        </div>
      )}
    </div>
  );
}
